// @flow
import BluebirdPromise from 'bluebird';

import * as r from './resources';
import type {
  UsersQuery,
  UsersQueryResponse,
  ManagedUser,
  SerializedManagedUser,
  AssociatedCustomerResponse,
} from '../user';
import {
  get,
  post,
  put,
  del,
  jsonForResourceRequest,
  rangeString,
  jsonForRequest,
} from './http';

import type { Dispatch, GetState } from '~/store';

export const managedUsers = (): ((
  dispatch: Dispatch,
  getState: GetState,
) => BluebirdPromise<mixed>) => get(r.managedUsers);

export const updateUser = (
  user: ManagedUser,
  updates: { user: SerializedManagedUser },
): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  put(r.user, user.id, updates);

export const updateUserIsDisabled = (
  user: ManagedUser,
  updates: { user: SerializedManagedUser },
): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  put(r.user, user.id, updates, false);

export const deleteUser = (
  user: ManagedUser,
): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  del(r.user, user.id);

export const createManagedUser = (params: {
  user: SerializedManagedUser,
}): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  post(r.managedUser, '', params);

export const usersQuery =
  (
    apiUrl: string,
    query: UsersQuery,
  ): ((start: number, count: number) => BluebirdPromise<UsersQueryResponse>) =>
  (start: number, count: number): BluebirdPromise<UsersQueryResponse> =>
    jsonForResourceRequest({
      apiUrl,
      resourceId: ({
        ...query,
        Range: rangeString({ start, count }),
      }: any),
      resource: r.users,
    });

export const associatedCustomer: (
  apiUrl: string,
) => (number: string) => Promise<AssociatedCustomerResponse> =
  (apiUrl) => (number) =>
    jsonForRequest({
      url: `${apiUrl}customers/${number}/associated_customer/`,
      method: 'GET',
    });

export const getBrandAdminLink: (
  apiUrl: string,
) => (id: string) => Promise<{ url: string }> = (apiUrl) => (id) =>
  jsonForRequest({
    url: `${apiUrl}users/${id}/brand_management`,
    method: 'GET',
  });
